import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class PermissionsService {
  http = inject(HttpClient);
  constructor() {}

  isAuthorizedUser(): Observable<boolean> {
    return this.http.post<any>(environment.apiUrl + '/auth/user', {}); 
  }
}